import { createFileRoute } from '@tanstack/react-router'

import { BackofficeInsurancePage as PlatformDocumentationPage } from '../../../components/pages/backoffice/platform/platform-documentation/index.tsx'

export const Route = createFileRoute('/bo/documentation/')({
  component: () => <PlatformDocumentationPage />,
})
